import { render, staticRenderFns } from "./OrderAccountingDocs.vue?vue&type=template&id=6e5f78bf&scoped=true"
import script from "./OrderAccountingDocs.vue?vue&type=script&lang=js"
export * from "./OrderAccountingDocs.vue?vue&type=script&lang=js"
import style0 from "./OrderAccountingDocs.vue?vue&type=style&index=0&id=6e5f78bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5f78bf",
  null
  
)

export default component.exports